import * as amplitude from "@amplitude/analytics-browser";
import { toAmplitudeUserId } from "@/lib/analytics/adapters/amplitude.ids";
import type {
  ClientAnalyticsAdapter,
} from "@/lib/analytics/types";

let initialized = false;

function apiKey(): string {
  return process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY?.trim() ?? "";
}

export const amplitudeClientAdapter: ClientAnalyticsAdapter = {
  name: "amplitude",

  init() {
    const key = apiKey();
    if (!key || typeof window === "undefined" || initialized) return;
    amplitude.init(key, {
      // Numeric Nurse Tools user ids can be < 5 chars; default minIdLength is 5.
      minIdLength: 1,
      defaultTracking: {
        pageViews: false,
        sessions: true,
        formInteractions: false,
        fileDownloads: false,
      },
    });
    initialized = true;
  },

  track(name, properties, eventId) {
    if (!apiKey() || !initialized) return;
    amplitude.track(name, properties ?? {}, { insert_id: eventId });
  },

  identify(userId, traits) {
    if (!apiKey() || !initialized) return;
    const amplitudeUserId = toAmplitudeUserId(userId);
    if (amplitudeUserId) {
      amplitude.setUserId(amplitudeUserId);
    }
    if (traits && Object.keys(traits).length > 0) {
      const identifyObj = new amplitude.Identify();
      for (const [key, value] of Object.entries(traits)) {
        if (value === undefined || value === null) continue;
        identifyObj.set(key, value as string | number | boolean);
      }
      amplitude.identify(identifyObj);
    }
  },

  reset() {
    if (!initialized) return;
    amplitude.reset();
  },
};

export function getAmplitudeDeviceId(): string | null {
  if (!initialized) return null;
  try {
    return amplitude.getDeviceId() ?? null;
  } catch (err) {
    console.error("[analytics:amplitude] getDeviceId failed", err);
    return null;
  }
}
